import { findIndex } from "lodash";
import * as actionType from "./ActionTypes";

export default function ContainerDischargeReportReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.DISCHARGE_REPORT_LOAD:
      return (state = payload);
    case actionType.DISCHARGE_REPORT_GATE_OUT:
      var finalGateOutPayload = [...state];
      const findId = findIndex(state, (data) => {
        return (
          data.ContainerMasterId.toString() === payload.Id.toString()
        );
      });
      for (let i = 0; i < state.length; i++) {
        if (
          state[i].ContainerMasterId.toString() === payload.Id.toString()
        ) {
          finalGateOutPayload[findId] = {
            ...state[i],
            Gate_Out_Date: payload.value,
          };
        }
      }
      return finalGateOutPayload;
    default:
      return state;
  }
}
